import { render, staticRenderFns } from "./k3-swiper.vue?vue&type=template&id=49af8cf8&scoped=true"
import script from "./k3-swiper.vue?vue&type=script&lang=js"
export * from "./k3-swiper.vue?vue&type=script&lang=js"
import style0 from "./k3-swiper.vue?vue&type=style&index=0&id=49af8cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49af8cf8",
  null
  
)

export default component.exports